// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3x9uN","content":"LoadingAlert_content__1aFP3"};